module.exports = __webpack_public_path__ + "img/gallery15.64b0d85.jpg";